import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import MainCampaignIMG from "../../../assets/img/campaign_main.jpg";
import { RootState } from "../store";

export interface LandingState {
  isLoadingApp: boolean;
  idViewIcon: number;
}

const initialState: LandingState = {
  isLoadingApp: false,
  idViewIcon: 0,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    updateLoadingApp: (state, action: PayloadAction<boolean>) => {
      state.isLoadingApp = action.payload;
    },
    updateViewIcon: (state, action: PayloadAction<number>) => {
      state.idViewIcon =
        action.payload == state.idViewIcon ? 0 : action.payload;
    },
  },
});

export const {
  updateLoadingApp,
  updateViewIcon,
} = appSlice.actions;

export const getIsLoadingApp = (state: RootState) => state.app.isLoadingApp;
export const getIdViewIcon = (state: RootState) => state.app.idViewIcon;

export default appSlice.reducer;
